"use strict";

var _classCallCheck = require("/opt/atlassian/pipelines/agent/build/node_modules/gatsby/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/opt/atlassian/pipelines/agent/build/node_modules/gatsby/node_modules/@babel/runtime/helpers/createClass");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RollUpdater = void 0;

function updateRoll(particle, delta) {
  var roll = particle.options.roll;
  var speed = particle.rollSpeed * delta.factor;
  var max = 2 * Math.PI;

  if (!roll.enable) {
    return;
  }

  particle.rollAngle += speed;

  if (particle.rollAngle > max) {
    particle.rollAngle -= max;
  }
}

var RollUpdater = /*#__PURE__*/function () {
  function RollUpdater() {
    _classCallCheck(this, RollUpdater);
  }

  _createClass(RollUpdater, [{
    key: "isEnabled",
    value: function isEnabled(particle) {
      var roll = particle.options.roll;
      return !particle.destroyed && !particle.spawning && roll.enable;
    }
  }, {
    key: "update",
    value: function update(particle, delta) {
      if (!this.isEnabled(particle)) {
        return;
      }

      updateRoll(particle, delta);
    }
  }]);

  return RollUpdater;
}();

exports.RollUpdater = RollUpdater;